/**
 * Created by Ning Jiang on 3/4/2020.
 */

import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {AnimatedParticle, Emitter} from "pixi-particles";

export class BigWinParticles extends PIXI.Container {

    private _coinConfigs:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.5,
                "end" : 0.5,
                "minimumScaleMultiplier" : 1.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 0,
                "end" : 1000,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 0,
                "y" : 900
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 0,
                "max" : 360
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 0,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3,
                "max" : 3
            },
            "blendMode" : "normal",
            "frequency" : 0.04,
            "emitterLifetime" : -1,
            "maxParticles" : 200,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -80,
                "y" : -50,
                "w" : 160,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.5,
                "end" : 0.5,
                "minimumScaleMultiplier" : 1.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 0,
                "end" : 1000,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 0,
                "y" : 900
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 0,
                "max" : 360
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 0,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3,
                "max" : 3
            },
            "blendMode" : "normal",
            "frequency" : 0.03,
            "emitterLifetime" : -1,
            "maxParticles" : 200,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -110,
                "y" : -50,
                "w" : 220,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.5,
                "end" : 0.5,
                "minimumScaleMultiplier" : 1.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 0,
                "end" : 1000,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 0,
                "y" : 900
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 0,
                "max" : 360
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 0,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3,
                "max" : 3
            },
            "blendMode" : "normal",
            "frequency" : 0.02,
            "emitterLifetime" : -1,
            "maxParticles" : 200,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -140,
                "y" : -50,
                "w" : 280,
                "h" : 1
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.6,
                "end" : 0.6,
                "minimumScaleMultiplier" : 1.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 0,
                "end" : 1000,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 0,
                "y" : 900
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 0,
                "max" : 360
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 0,
                "max" : 150
            },
            "lifetime" : {
                "min" : 3,
                "max" : 3
            },
            "blendMode" : "normal",
            "frequency" : 0.01,
            "emitterLifetime" : -1,
            "maxParticles" : 300,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -640,
                "y" : -50,
                "w" : 1280,
                "h" : 1
            }
        }
    ];

    private _coinParticles:any[] = [
        [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("bigWinSilverCoin")
            }
        ],
        [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("bigWinSilverCoin")
            },
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("bigWinGoldCoin")
            }
        ],
        [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("bigWinGoldCoin")
            }
        ],
        [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("bigWinSilverCoin")
            },
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures("bigWinGoldCoin")
            }
        ]
    ];

    private _starConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0.5
        },
        "scale" : {
            "start" : 0.2,
            "end" : 0.5,
            "minimumScaleMultiplier" : 2
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 0,
            "end" : 600,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : 500
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 10,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 100,
            "max" : 200
        },
        "lifetime" : {
            "min" : 4,
            "max" : 4
        },
        "blendMode" : "add",
        "frequency" : 0.03,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -80,
            "y" : -50,
            "w" : 160,
            "h" : 1
        }
    };

    private _coinEmitters:Emitter[] = [];
    private _starEmitter:Emitter;

    private _currentLevel:number;
    private _isPlaying:boolean = false;

    constructor() {
        super();
    }

    public play(level:number):void {
        this._isPlaying = true;
        this._currentLevel = level;
        for(let i:number = 0; i <= level; i++) {
            let coinEmitter:Emitter;
            if(this._coinEmitters[i]) {
                coinEmitter = this._coinEmitters[i];
            } else {
                coinEmitter = this.createEmitter(i);
                this._coinEmitters[i] = coinEmitter;
            }

            if(level === 3 && i < 3) {
                coinEmitter.emit = false;
            } else {
                coinEmitter.emit = true;
            }
        }

        if(!this._starEmitter) {
            this._starEmitter = new Emitter(this, [GameResources.getTextures("bigWinPt")[0]], this._starConfig);
            ParticlesManager.addEmitter(this._starEmitter);
        }
        this._starEmitter.emit = level != 3;
    }

    private createEmitter(level:number):Emitter {
        const emitter:Emitter = new Emitter(this, this._coinParticles[level], this._coinConfigs[level]);
        emitter.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(emitter);
        return emitter;
    }

    public stop():void {
        this._coinEmitters.forEach((emitter:Emitter) => {
            emitter.emit = false;
        });
        if(this._starEmitter) {
            this._starEmitter.emit = false;
        }
    }
}